import React from 'react'
import * as UI from '@brewlogix/blx-ui'
import Image from 'next/image'
import { useFilterStore } from '../../state/filterStore'

const IndependentCraftToggle: React.FC = () => {
    const { setIndependentCraftOnly, independentCraftOnly, setFilterCount } = useFilterStore()

    const handleSetIndependentCraftOnly = () => {
        setIndependentCraftOnly(!independentCraftOnly)
        setFilterCount()
    }

    return (
        <div className='mt-4 flex w-full items-center'>
            <UI.Toggle
                id='toggle-independent-craft'
                size='sm'
                name='Independent Craft'
                onChange={handleSetIndependentCraftOnly}
            />
            <Image
                src='/assets/ba-certified.svg'
                alt='Brewery Association Certified Logo'
                height='50px'
                width='50px'
            />
            Only Independent Craft
        </div>
    )
}

export default React.memo(IndependentCraftToggle)
